<template>
  <Breadcrumbs title="" />
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12" v-if="this.eventDetails.is_hybrid === 'N'">
        <div class="card">
          <div class="card-header" v-if="this.eventDetails.title">
            <div class="d-flex justify-content-center">
              <figure class="col-xl-12 col-sm-12">
                <img style="width: 100%;box-shadow: 0em 0em 1em rgb(0 0 0 / 50%);border-radius: 0.6em;border: none;padding: 0;background: transparent;"
                  :src="this.eventDetails.coverurl"
                  alt="Image description"
                />
              </figure>
            </div>
            <h3 style="text-align: center;">{{ this.eventDetails.title }}</h3>
            <hr>
            <h5 style="text-align: center;">กิจกรรมนี้ไม่รองรับรูปแบบการเหมา </h5>
            <h3 style="text-align: center;"><u><a :href="'../'+this.$route.params.event_id">กลับไปยังกิจกรรมหลัก</a></u></h3>
          </div>
        </div>
      </div>
      <div class="col-sm-12" v-if="this.eventDetails.is_hybrid === 'Y'">
        <div class="card">
          <div class="card-header" v-if="this.eventDetails.title">
            <div class="d-flex justify-content-center">
              <figure class="col-xl-12 col-sm-12">
                <img style="width: 100%;box-shadow: 0em 0em 1em rgb(0 0 0 / 50%);border-radius: 0.6em;border: none;padding: 0;background: transparent;"
                  :src="this.eventDetails.coverurl"
                  alt="Image description"
                />
              </figure>
            </div>
            <h5>{{ this.eventDetails.title }}</h5>
           
                <p style="font-size: small; line-height: 1.2;">
                  <i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{ this.eventDetails.event_date_text }}<br />
                  &nbsp;<i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp; {{ this.eventDetails.province }}<br />
                  {{ this.currentLanguage === 'en' ? "Open search at" : "ช่วงเวลาที่เปิดขาย" }}: {{ this.eventDetails.on_sale_start }}
                  <span>
                    &nbsp;{{ this.currentLanguage === 'en' ? "To" : "ถึงวันที่" }}: {{ this.eventDetails.on_sale_end }}
                    <template v-if="this.eventDetails.day_diff <= 10 && this.eventDetails.day_diff > 0">
                      <font style="color: red">
                        ({{ this.currentLanguage === 'en' ? "There is still time left to store photo" : "คงเหลือเวลาจัดเก็บรูปอีก" }} {{ this.eventDetails.day_diff }} {{ this.currentLanguage === 'en' ? "days" : "วัน" }})
                      </font>
                    </template>
                  </span>
                </p>
            <p>
              <span style="padding: 5px;margin: 3px;"
                v-for="(_package, index) in this.eventDetails.package_hb"
                :key="index"
                class="btn btn-outline-info"
                ><b>&nbsp;{{this.currentLanguage ==='en'?_package.name_en:_package.name}}</b>
              </span>
            </p>
            <a v-if="this.eventDetails.is_hybrid === 'Y' && cart_store_wholesale.cart_images.length === 0" :href="'../'+this.$route.params.event_id">
              <button class="btn btn-lg btn-primary" style="width: 100%" >{{this.currentLanguage ==='en'?"Price package":"ซื้อราคาแพ็กเกจ"}}</button></a>
            
            <div v-if="this.eventDetails.is_hybrid === 'Y' && this.eventDetails.is_mhao_hybrid === 'N' && cart_store_wholesale.cart_images.length === 0" class="d-flex justify-content-center" >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.currentLanguage ==='en'?"Note* buy all items per one face searched. or one time searching by event. If you want to buy some images You can click on the main package.":"หมายเหตุ* การเหมา เป็นการเหมาต่อ 1 ใบหน้าที่ค้นหา หากต้องการซื้อเพียงบางภาพ สามารถกดที่ ซื้อราคาแพ็กเกจ ( แนะนำใช้รูปใบหน้าที่ชัดเจนเพียงใบหน้าเดียว และได้ภาพมากที่สุดในการค้นหา เพื่อกดเหมา อาจจะลองค้นหาหลายๆ ครั้งด้วยรูปที่ต่างกันเพื่อให้เจอรูปมากที่สุด และถูกใจที่สุดก่อนกดเหมา )"}}
            </div>
            <div v-if="this.eventDetails.is_hybrid === 'Y' && this.eventDetails.is_mhao_hybrid === 'Y' && cart_store_wholesale.cart_images.length === 0" class="d-flex justify-content-center" >
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.currentLanguage ==='en'?"Note* buy all items per one face searched. or one time searching by event. If you want to buy some images You can click on the main package.":"หมายเหตุ* การเหมา เป็นการเหมาต่อ 1 ใบหน้าที่ค้นหา หากต้องการซื้อเพียงบางภาพ สามารถกดที่ ซื้อราคาแพ็กเกจ ( แนะนำใช้รูปใบหน้าที่ชัดเจนเพียงใบหน้าเดียว และได้ภาพมากที่สุดในการค้นหา เพื่อกดเหมา อาจจะลองค้นหาหลายๆ ครั้งด้วยรูปที่ต่างกันเพื่อให้เจอรูปมากที่สุด และถูกใจที่สุดก่อนกดเหมา )"}}</p>
            </div>
            <div class="row">
              <!-- <div class="col-sm-1"></div> -->
              <div class="col-sm-12" v-if="this.eventDetails.can_sale === 'Y'">
                <div v-if="this.eventDetails.close_sale === 'N'">
                <label
                  for="fileInput"
                  class="drop-container"
                  id="dropcontainer"
                  @change="faceSearch"
                  
                >
                  <span class="drop-title" v-if="isSearching !== 'true'"
                    ><vue-feather
                      type="image" size="36"
                      class="text-top"
                    ></vue-feather><br>
                    {{this.currentLanguage ==='en'?"upload you face for find images":"อัปโหลดภาพใบหน้าเพื่อค้นหา..."}}</span
                  >
                  
                  <span class="drop-title" v-if="isSearching === 'true' && !isUploading"
                    ><img style="align-items: center; width: 30px"
                        src="../../assets/images/running_loading.svg"
                      />
                    <!-- <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> -->
                    {{this.currentLanguage ==='en'?"Searching...":"กำลังค้นหา..."}}</span
                  >
                  
                  <span class="drop-title" v-if="isUploading"
                    >
                    {{this.currentLanguage ==='en'?"Uploading...":"กำลังอัปโหลด..."}}<br>
                    <div class="progress-container">
                      <div class="progress-bar" :style="{width: uploadProgress + '%'}"></div>
                    </div>
                    <small>{{ uploadProgress }}%</small>
                  </span>
                  <input
                    class="btn btn-square btn-outline-info btn-lg"
                    type="file"
                    id="fileInput"
                    accept="image/png, image/jpeg"
                    required
                  />
                </label>
              </div>
              <div  v-else>
                <div class="d-flex justify-content-center">
                  <vue-feather type="clock" size="17"></vue-feather>
                </div>
                <div class="d-flex justify-content-center">
                  {{this.currentLanguage ==='en'?"End of Sale":"กิจกรรมนี้ ปิดการขายแล้ว"}}
                </div>
                
                
              </div>
              </div>
              <div class="col-sm-12" v-if="this.eventDetails.can_sale === 'N'">
                <p>&nbsp;</p>
                <div class="d-flex justify-content-center">
                  
                  <b>
                    {{this.currentLanguage ==='en'?"Please come back to search at":"เปิดให้ค้นหา"}} {{ this.eventDetails.on_sale_start_txt }}
                  </b>
                </div>
               <hr>
                <div class="d-flex justify-content-center">
                   {{this.currentLanguage ==='en'?"Alternatively, you can follow us at":"หรือสามารถมารถติดตามพวกเราได้ที่"}}
                </div>
                <div class="d-flex justify-content-center">
                  <a :href="fbUrl" target="_blank"><h5><img style="align-items: center; height: 40px" src="../../assets/images/running/facebook-icon.png" />  {{fbName}}</h5></a>
                </div>
              </div>
              <!-- <div class="col-sm-1"></div> -->
            </div>
          </div>

          <div class="card-header" v-if="!this.eventDetails.title">
            <div class="d-flex justify-content-center" >
                <img style="align-items: center; width: 60px"
                        src="../../assets/images/running_loading.svg"
                      />
            </div>
            <div class="d-flex justify-content-center">
              {{this.currentLanguage ==='en'?"loading...":"กำลังโหลดข้อมูลกิจกรรม..."}}
            </div>
          </div>
        </div>
        <div class="card" v-if="this.is_show_image_search === 'Y'">
          <div v-if="cart_store_wholesale.cart_images.length > 0">
            <p></p>
            <button
              style="width: 100%"
              v-if="
                this.eventDetails.is_free_download === 'Y' &&
                this.images_download_all.length > 0
              "
              type="button"
              class="btn btn-primary"
              @click.prevent="load_images()"
            >
            {{this.currentLanguage ==='en'?"Download all photos":"ดาวน์โหลดรูปทั้งหมด"}}
            </button>
            <p style="text-align: center">
              {{this.currentLanguage ==='en'?"Found matching face ":"ค้นพบภาพของท่านจำนวน "}}<b> {{ cart_store_wholesale.cart_images.length }}</b> {{this.currentLanguage ==='en'?"items":"ใบ"}}
            </p>


            
            <button  v-if=" cart_store_wholesale.cart_images.length > 0 && this.eventDetails.is_free_download_keep_contract === 'Y' " class="btn btn-lg btn-primary"
              @click="
                cart_store_wholesale.addToCartALLImage(
                  cart_store_wholesale.cart_images,
                  'N',
                  0
                ) " style="width: 100%" >
              +<vue-feather type="shopping-cart" stroke-width="2"></vue-feather> {{this.currentLanguage ==='en'?"Add all to cart":"เลือกรูปทั้งหมดใส่ตะกร้า"}}
            </button>

            <button  v-if=" cart_store_wholesale.cart_images.length > 0 && this.eventDetails.is_hybrid === 'Y' " class="btn btn-lg btn-primary"
              @click="
                cart_store_wholesale.addToCartALLImage(
                  cart_store_wholesale.cart_images,
                  this.eventDetails.is_hybrid,
                  this.eventDetails.hybrid_mhao_price
                ) " style="width: 100%" >
              +<vue-feather type="shopping-cart" stroke-width="2"></vue-feather> ซื้อโปร เหมาๆ ได้รูปทั้งหมดที่ค้นเจอ
              ( {{this.currentLanguage ==='en'?"Avg":"เฉลี่ย"}} {{ Number(this.eventDetails.hybrid_mhao_price/cart_store_wholesale.cart_images.length).toFixed(2) }} ) {{this.currentLanguage ==='en'?"per items":"ต่อใบ"}}
            </button>
            <p></p>
            <div style="margin: 10px;" v-if=" cart_store_wholesale.cart_images.length > 0 && this.eventDetails.is_hybrid === 'Y' && this.eventDetails.is_mhao_hybrid === 'N' " class="d-flex justify-content-center" >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.currentLanguage ==='en'?"Note* buy all items per one face searched. or one time searching by event. If you want to buy some images You can click on the main package.":"หมายเหตุ* การเหมา เป็นการเหมาต่อ 1 ใบหน้าที่ค้นหา หากต้องการซื้อเพียงบางภาพ สามารถกดที่ ซื้อราคาแพ็กเกจ ( แนะนำใช้รูปใบหน้าที่ชัดเจนเพียงใบหน้าเดียว และได้ภาพมากที่สุดในการค้นหา เพื่อกดเหมา อาจจะลองค้นหาหลายๆ ครั้งด้วยรูปที่ต่างกันเพื่อให้เจอรูปมากที่สุด และถูกใจที่สุดก่อนกดเหมา )"}}
            </div>
            <div style="margin: 10px;" v-if=" cart_store_wholesale.cart_images.length > 0 && this.eventDetails.is_hybrid === 'Y' && this.eventDetails.is_mhao_hybrid === 'Y'" class="d-flex justify-content-center" >
              <p>{{this.currentLanguage ==='en'?"Note* buy all items per one face searched. or one time searching by event. If you want to buy some images You can click on the main package.":"หมายเหตุ* การเหมา เป็นการเหมาต่อ 1 ใบหน้าที่ค้นหา หากต้องการซื้อเพียงบางภาพ สามารถกดที่ ซื้อราคาแพ็กเกจ ( แนะนำใช้รูปใบหน้าที่ชัดเจนเพียงใบหน้าเดียว และได้ภาพมากที่สุดในการค้นหา เพื่อกดเหมา อาจจะลองค้นหาหลายๆ ครั้งด้วยรูปที่ต่างกันเพื่อให้เจอรูปมากที่สุด และถูกใจที่สุดก่อนกดเหมา )"}}</p>
            </div>

            <div id="imageShowing">
              <div class="masonry-container">
                <div
                  v-for="(src, index) in cart_store_wholesale.cart_images"
                  :key="index"
                  class="masonry-item"
                >
                  <div class="gallery event masonry-content">
                    <img
                      loading="lazy"
                      :src="src.thumbnail_file_name"
                      :alt="src.original_file_name"
                      @click="() => showImg(index)"
                      @load="onImageLoad"
                    />

                    <button style="font-size: small;"
                      v-if="
                        src.atc == 'N' &&
                        this.eventDetails.is_free_download === 'Y'
                      "
                      class="btn-free-download"
                      @click="
                        this.download(
                          src.preview_file_name + '?openExternalBrowser=1'
                        ),
                          addToCart()
                      "
                    >
                    Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="this.isFoundImage !== 'true'"
            class="d-flex justify-content-center"
          >
            <div class="card-header">
              <h5>{{this.currentLanguage ==='en'?"Can't find the picture, try changing the picture used to search. Or choose a picture that has only one face in it and is clear, and try again.":"ไม่พบรูป, ลองเปลี่ยนรูปที่ใช้ในการค้นหา หรือเลือกรูปที่มีใบหน้าเพียงคนเดียวในรูป และชัดเจน  แล้วลองอีกครั้ง"}}</h5>
              <p>{{this.currentLanguage ==='en'?"Can't find it? Try asking the admin to help you find it. You can send pictures to":"หาไม่เจอ ลองให้แอดมินช่วยหามั๋ย ส่งรูปมาได้เลยที่"}} <a :href="fbUrl" target="_blank"> {{fbName}}</a></p>
            </div>
          </div>
          <vue-easy-lightbox
            pinchDisabled="true"
            scrollDisabled="true"
            :zoomDisabled="this.is_show_image_search==='Y'?true:false"
            loop="true"
            rotateDisabled="true"
            moveDisabled="true"
            :visible="visible"
            :index="index"
            :imgs="this.is_show_image_search==='Y'?lightBoxImages:lightBoxImages_hl"
            @hide="handleHide"
          >
            <!-- <template v-slot:close-btn="{  }">
           
          </template> -->

            <template v-slot:toolbar="{}">
              <!-- <button class="close-btn" @click="this.addToCartlb(index)">add+</button>
              <button @click="toolbarMethods.zoomIn">zoom in</button>
            <button @click="toolbarMethods.zoomOut">zoom out</button>
            <button @click="toolbarMethods.rotateLeft">Anticlockwise rotation</button>
            <button @click="toolbarMethods.rotateRight">clockwise rotation</button> -->
            </template>
          </vue-easy-lightbox>
        </div>
        <div class="card" v-if="this.is_show_image_search !== 'Y' && this.data_highlight.length>0">
          <b style="text-align: center;padding-bottom: 5px;"> <vue-feather type="bar-chart" size="20"></vue-feather> {{this.currentLanguage ==='en'?"Event highlight":"Highlight ภาพกิจกรรม"}}  </b>
          <div v-if="this.loadding_highlight !== 'Y'" class="masonry-container">
            <div
              v-for="(src, index_hl) in this.data_highlight"
              :key="index_hl"
              @click="() => showImg(index_hl)"
              class="masonry-item"
            >
              <div class="gallery_hl event_hl masonry-content">
                <img
                  loading="lazy"
                  :src="src.thumbnail_file_name"
                  :alt="src.original_file_name"
                  @load="onImageLoad"
                />
              </div>
            </div>
          </div>
          <div v-if="this.loadding_highlight === 'Y'"  >
              <div class="d-flex justify-content-center" >
                <img style="align-items: center; width: 60px"
                        src="../../assets/images/running_loading.svg"
                      />
              </div>
          </div>
          <p>&nbsp;</p>
          <vue-easy-lightbox
            pinchDisabled="true"
            scrollDisabled="true"
            :zoomDisabled="this.is_show_image_search==='Y'?true:false"
            loop="true"
            rotateDisabled="true"
            moveDisabled="true"
            :visible="visible"
            :index="index"
            :imgs="this.is_show_image_search==='Y'?lightBoxImages:lightBoxImages_hl"
            @hide="handleHide"
          >
            <!-- <template v-slot:close-btn="{  }">
           
          </template> -->

            <template v-slot:toolbar="{}">
              <!-- <button @click="toolbarMethods.zoomIn">zoom in</button>
            <button @click="toolbarMethods.zoomOut">zoom out</button>
            <button @click="toolbarMethods.rotateLeft">Anticlockwise rotation</button>
            <button @click="toolbarMethods.rotateRight">clockwise rotation</button> -->
            </template>
          </vue-easy-lightbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.js";

import "@sweetalert2/theme-bootstrap-4/bootstrap-4.scss";
import { ref } from "vue";
import router from "../../router";
import { useCartStoreWholesale } from "../../store/modules/cart_wholesale";
import axios from "axios";
import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'
const isBtnaddToCartClick = ref(0);
const isBtnshowImgClick = ref(0);

export default {
  setup() {
    const siteData = reactive({
      title: process.env.VUE_APP_SYSTEM_TITLE || '',
      description: process.env.VUE_APP_SYSTEM_DESCRIPTION || ``,
      keywords: process.env.VUE_APP_SYSTEM_KEYWORDS ||   ``,
      image:  process.env.VUE_APP_WEBSITE_IMAGE || '',
      
    })

    useHead({
      // Can be static or computed this.eventDetails.title
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: `og:image`,
          content: computed(() => siteData.image),
        },
        ],
     
    })

    
    const cart_store_wholesale = useCartStoreWholesale();
    cart_store_wholesale.loadFromLocalStorage();
    return { cart_store_wholesale ,siteData};
  },

  data() {
    return {
      fbName: process.env.VUE_APP_SYSTEM_FACEBOOK_NAME,
      fbUrl: process.env.VUE_APP_SYSTEM_FACEBOOK_URL,
      system_prefix: process.env.VUE_APP_SYSTEM_PREFIX || '',
      isSearching: "false",
      isFoundImage: "true",
      eventDetails: {},
      eventPackage: {},
      lightBoxImages: [],
      visible: false,
      index: "",
      cart: [],
      imgs_avg_price: 0,
      images_download_all: [],


      lightBoxImages_hl: [],
      index_hl: "",
      visible_hl: false,
      loadding_highlight: "",
      data_highlight: [],
      is_show_image_search: "" ,
      currentLanguage: 'th',
      resizeTimeout: null,
      windowWidth: window.innerWidth,
      layoutTimeout: null,
      uploadProgress: 0,
      isUploading: false,


    
    };
  },
  
  watch: {
    windowWidth: {
      handler(newWidth, oldWidth) {
        // Clear any existing timeouts
        if (this.layoutTimeout) {
          clearTimeout(this.layoutTimeout);
        }
        if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
        }
        
        // Immediate layout for responsive feedback
        this.layoutMasonryRealtime();
        
        // Precise layout after a short delay
        this.layoutTimeout = setTimeout(() => {
          this.layoutMasonry();
        }, 500);
      },
      immediate: false
    }
  },
  async created(){
    this.currentLanguage = localStorage.getItem('currentLanguage');
  },
  async mounted() {
    let _data = await this.getEventDetail(this.$route.params.event_id);
    this.siteData.image = _data.coverurl ;
    this.siteData.title = _data.title +' '+this.siteData.title ;
    this.siteData.description = _data.title +' วันที่ '+_data.event_date_text+' ณ.'+_data.province+' '+this.siteData.description ;
    
    if (this.lightBoxImages.length <= 0) {
      this.lightBoxImages.length = [];
      this.images_download_all = [];
      
      if(this.cart_store_wholesale.cart_images.length > 0 ){
        this.is_show_image_search = "Y"
        this.cart_store_wholesale.cart_images.forEach((item) => {
        
        this.lightBoxImages.push({
          src: item.preview_file_name,
          title:
            "IMAGEID:" +
            this.$route.params.event_id +
            "" +
            item.photographer_id +
            "" +
            item.id,
        });
        this.images_download_all.push(item.preview_file_name);
      });
      this.imgs_avg_price  = (this.eventDetails.hybrid_mhao_price/this.cart_store_wholesale.cart_images.length).toFixed(2)
      }

    }

    // Setup masonry layout after highlight images load
    this.$nextTick(() => {
      setTimeout(() => {
        this.layoutMasonry();
      }, 10);
    });

    // Listen for window resize with immediate response and reactive update
    window.addEventListener('resize', this.handleResizeReactive, { passive: true });
    
    // Also listen for orientation change on mobile devices
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.windowWidth = window.innerWidth; // Update reactive property
        this.layoutMasonry();
      }, 10);
    });

    this.highlight();
  },
  beforeUnmount() {
    // Clean up event listeners
    window.removeEventListener('resize', this.handleResizeReactive);
    window.removeEventListener('orientationchange', this.handleResize);
    
    // Clear any pending timeouts
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    if (this.layoutTimeout) {
      clearTimeout(this.layoutTimeout);
    }
  },
  methods: {
    async highlight() {
      this.loadding_highlight = "Y";
      let data = {
        event_key: this.$route.params.event_id,
      };
      const response = await axios.post("/v1/facesearch/highlight", data);

      if (response.data.status === "success") {
        this.data_highlight = response.data.body;

        this.data_highlight.forEach((item) => {
          this.lightBoxImages_hl.push({
            src: item.preview_file_name,
            title: 'ตัวอย่างภาพความประทับใจ',
          });
        
      });

        this.loadding_highlight = "N";
        
        // Layout masonry after images are loaded with multiple attempts
        this.$nextTick(() => {
          // Final attempt after all resources should be loaded
          setTimeout(() => {
            this.layoutMasonry();
          }, 10);
        });
      } else {
        this.loadding_highlight = "N";
        //alert("Load order พบข้อผิดพลาด!");
      }
    },
    async sleep_only() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, 200);
      });
    },
    async load_images() {
      let result = await Swal.fire({
        icon: "info",
        title:
          "กรุณาเปิดอนุญาตป๊อปอัป เมื่อเริ่มดาวน์โหลด,  ระบบจะดาวน์โหลดรูปทั้งหมด อัตโนมัติ ",
        html: "<b><u>แนะนำใช้งานผ่านคอมพิวเตอร์หรือระบบแอนดรอยด์</u></b>,<br> บนระบบ ios ระบบจะเปิดแทบเท่ากับจำนวนรูปเพื่อให้กดค้างเพื่อบันทึก <br>คุณต้องการดาวน์โหลดรูปทั้งหมดใช่หรือไม่?",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#7991a8",
        confirmButtonText: "เริ่มดาวน์โหลด",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          let count = 0;
          while (count < this.images_download_all.length) {
            window.open(
              this.images_download_all[count] + "?openExternalBrowser=1",
              "_blank"
            );
            this.sleep_only();
            count++;
          }
        } else {
          return false;
        }
      });
    },
    async download(url) {
      window.open(url, "_blank");
    },
    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/" + event_key);
      if (res.data.status === "success") {
        this.eventDetails = res.data;
        this.eventPackage = res.data.package;

        let consent_check = localStorage.getItem(
          "consent_" + this.$route.params.event_id
        );
        if (consent_check !== "true") {
          if(this.currentLanguage === 'en'){
            let result = await this.cart_store_wholesale.alert_policy_consent_en();
            if (result) {
              localStorage.setItem(
                "consent_" + this.$route.params.event_id,
                "true"
              );
            } else {
              router.push({ path: "/" });
            }
          }else{
            let result = await this.cart_store_wholesale.alert_policy_consent();
            if (result) {
              localStorage.setItem(
                "consent_" + this.$route.params.event_id,
                "true"
              );
            } else {
              router.push({ path: "/" });
            }
          }
          

        }
        return res.data;
      } else {
        //alert("พบข้อผิดพลาด! ไม่พบ url ของกิจกรรม");
        router.push({ path: "/404" });
      }
    },
    addToCart() {
      isBtnaddToCartClick.value = 1;
    },
    addAllImageToCart() {
      //router.push({ path: "cart" });
    },
    showImg(index) {
      isBtnshowImgClick.value = 1;

      if (isBtnaddToCartClick.value === 0) {
        this.index = index;
        this.visible = true;
      }
      isBtnaddToCartClick.value = 0;
      isBtnshowImgClick.value = 0;
    },
    handleHide() {
      this.visible = false;
      isBtnaddToCartClick.value = 0;
      isBtnshowImgClick.value = 0;
    },
    faceSearch() {
      if(this.eventDetails.is_hybrid === 'Y'){
        
        if(this.cart_store_wholesale.cart.length > 0){
          if(confirm(this.currentLanguage==='en'?"You have photos in your shopping cart. If you search again The pictures in the basket will be Automatically deleted Do you want to continue the transaction?":"ท่านมีรูปที่ทำรายการค้างอยู่ในตะกร้า ถ้าหากค้นหาใหม่อีกครั้ง รูปที่อยู่ในตะกร้าจะถูก ลบออกโดยอัตโนมัติ  ต้องการทำรายการต่อใช่หรือไม่?")){
            this.cart_store_wholesale.clear_cart(this.eventDetails.is_hybrid)
            this.faceSearchV2_action();
          }else{
            document.getElementById("fileInput").value = null;
          }

        }else{ 
          this.faceSearchV2_action();
        }

      }else{
        this.faceSearchV2_action();
      }

        

      
    },
    faceSearch_action_notuse(){
      if (document.getElementById("fileInput").value != "") {
        var file_size = fileInput.files[0].size / 1000000;
        if(fileInput.files[0].type === 'image/jpeg' || fileInput.files[0].type === 'image/png'){
          this.lightBoxImages = [];
        this.isSearching = "true";
        this.is_show_image_search = "Y"
        this.isFoundImage = "true";
        this.cart_store_wholesale.clear_cart_images();
        this.cart_store_wholesale.clear_cart_latest();
        this.imgs_avg_price = 0;
        document.getElementById("fileInput").disabled = true;
        var formdata = new FormData();
        //var requestOptions = {
        //  method: "POST",
        //  body: formdata,
        //  redirect: "follow",
        //};
        formdata.append("file", fileInput.files[0], fileInput.files[0].name);
        formdata.append("event_id", this.eventDetails.event_id);
        formdata.append("event_key", this.$route.params.event_id);
        formdata.append("face_threshold", this.eventDetails.face_threshold);
        //TODO
        formdata.append("mhao_price", this.eventDetails.hybrid_mhao_price);
        formdata.append("max_face_search", this.eventDetails.max_face_search);
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };
        fetch(
          process.env.VUE_APP_RUNNING_API + "/v1/facesearch",
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            result = JSON.parse(result);

            if (result.status === "success") {
              if (result.image_length > 0) {
                this.isFoundImage = "true";
                this.cart_store_wholesale.cart_images = result.images;

                if(this.eventDetails.is_hybrid === 'Y'){
                  this.cart_store_wholesale.cart_latest = result.images;
                }
                localStorage.setItem('cart_latest_wholesale', JSON.stringify(this.cart_store_wholesale.cart_latest))

                this.imgs_avg_price = result.avg_price;
                this.cart_store_wholesale.cart_images.forEach((item) => {
                  //this.lightBoxImages.push(item.preview_file_name);
                  this.lightBoxImages.push({
                    src: item.preview_file_name,
                    title:
                      this.$route.params.event_id +
                      ":" +
                      this.system_prefix +
                      item.photographer_id +
                      "-" +
                      "IMAGEID:" +
                      item.id,
                  });
                  this.images_download_all.push(item.preview_file_name);
                });
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
              } else {
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
                //alert("ไม่พบรรูปที่ตรงกัน");
                this.isFoundImage = "false";
              }
            } else {
              this.isSearching = "false";
              this.isFoundImage = "false";
              document.getElementById("fileInput").disabled = false;
              this.cart_store_wholesale.alert_commomd_message_info(
                "พบข้อผิดพลาดจากการค้นหา กรุณาลองอีกครั้ง"
              );
            }
            document.getElementById("fileInput").value = null;
          })
          .catch((error) => {
            // Handle error silently or with user-friendly message
          });
          
        }else{
          this.cart_store_wholesale.alert_commomd_message_info("กรุณาใช้ไฟล์ jpg หรือ png เพื่อค้นหาเท่านั้น");
        }
        
      
        
      }

    },
    async faceSearchV2_action(){
      if (document.getElementById("fileInput").value != "") {
        if(fileInput.files[0].type === 'image/jpeg' || fileInput.files[0].type === 'image/png'){
          this.lightBoxImages = [];
        this.isSearching = "true";
        this.isUploading = true;
        this.uploadProgress = 0;
        this.is_show_image_search = "Y"
        this.isFoundImage = "true";
        this.cart_store_wholesale.clear_cart_images();
        this.cart_store_wholesale.clear_cart_latest();
        this.imgs_avg_price = 0;
        document.getElementById("fileInput").disabled = true;


        return axios.post("/v2/photo/facesearch/sign", {
          event_key: this.$route.params.event_id,
          file_name: fileInput.files[0].name,
          file_type: "image/jpg"
        },)
        .then((presigned_response) => {
          return axios.put(presigned_response.data.url, fileInput.files[0], {
            headers: {
              "Content-Type": "image/jpg",
              "Content-Disposition": `inline; filename="${presigned_response.data.file_name}"`,
            },
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
          })
          .then((put_response) => {
            if(put_response.status === 200){
              // Upload completed, hide upload progress and show search progress
              this.isUploading = false;
              this.uploadProgress = 0;
              
              return axios.post("/v2/photo/facesearch", {
              search_id: presigned_response.data.search_id,
              file_location: presigned_response.data.file_location,
              event_id: this.eventDetails.event_id,
              event_key: this.$route.params.event_id,
              face_threshold: this.eventDetails.face_threshold,
              mhao_price: this.eventDetails.mhao_price,
              max_face_search: this.eventDetails.max_face_search,
            })
            .then((result_) => {
              
            let result = result_.data;

            if (result.status === "success") {
              if (result.image_length > 0) {
                this.isFoundImage = "true";
                this.cart_store_wholesale.cart_images = result.images;

                if(this.eventDetails.is_mhao === 'Y'){
                  this.cart_store_wholesale.cart_latest = result.images;
                }
                localStorage.setItem('cart_latest', JSON.stringify(this.cart_store_wholesale.cart_latest))

                this.imgs_avg_price = result.avg_price;
                this.cart_store_wholesale.cart_images.forEach((item) => {
                  this.lightBoxImages.push({
                    src: item.preview_file_name,
                    title:
                      this.$route.params.event_id +
                      ":" +
                      this.system_prefix +
                      item.photographer_id +
                      "-" +
                      "IMAGEID:" +
                      item.id,
                  });
                  this.images_download_all.push(item.preview_file_name);
                });
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
              } else {
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
                this.isFoundImage = "false";
              }
            } else {
              this.isSearching = "false";
              this.isFoundImage = "false";
              document.getElementById("fileInput").disabled = false;
              this.cart_store.alert_commomd_message_info(
                "พบข้อผิดพลาดจากการค้นหา กรุณาลองอีกครั้ง"
              );
            }
            document.getElementById("fileInput").value = null;

            this.$nextTick(() => {
              setTimeout(() => { this.layoutMasonry(); }, 100);
            });
              
            });
            }    
          })
          .catch((error) => {
            // Reset progress and search state on error
            this.isSearching = "false";
            this.isUploading = false;
            this.uploadProgress = 0;
            this.isFoundImage = "false";
            document.getElementById("fileInput").disabled = false;
            document.getElementById("fileInput").value = null;
            this.cart_store.alert_commomd_message_info(
              "พบข้อผิดพลาดจากการอัปโหลดหรือค้นหา กรุณาลองอีกครั้ง"
            );
          });
        });
          
        }else{
          this.cart_store.alert_commomd_message_info("กรุณาใช้ไฟล์ jpg หรือ png เพื่อค้นหาเท่านั้น");
        }
      }

    },
    addToCartlb(_image_id){
      // Handle add to cart from lightbox
    },
    onImageLoad(event) {
      // Re-layout masonry when images load with immediate response
      this.layoutMasonryRealtime();
      
      // Follow up with precise layout
      this.$nextTick(() => {
        setTimeout(() => {
          this.layoutMasonry();
        }, 10);
      });
    },
    
    handleResize() {
      // Update window width to trigger watcher
      this.windowWidth = window.innerWidth;
      
      // Clear any pending timeout
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      
      // Immediate real-time layout adjustment
      this.layoutMasonryRealtime();
      
      // Additional precise layout after a short delay for final positioning
      this.resizeTimeout = setTimeout(() => {
        this.layoutMasonry();
      }, 10);
    },
    
    handleResizeReactive() {
      // Update window width to trigger Vue watcher
      this.windowWidth = window.innerWidth;
      
      // The rest will be handled by the watcher
    },
    
    layoutMasonryRealtime() {
      this.layoutMasonry(true);
    },
    
    layoutMasonry(realtime = false) {
      document.querySelectorAll('.masonry-container').forEach(container => {
        if (container.offsetWidth === 0) return; // skip hidden containers
        this._layoutContainer(container, realtime);
      });
    },

    _layoutContainer(container, realtime = false) {
      const items = container.querySelectorAll('.masonry-item');
      if (items.length === 0) return;
      
      const gap = 5;
      const columns = this.getMasonryColumns();
      const columnHeights = new Array(columns).fill(0);
      
      const containerWidth = container.offsetWidth;
      const availableWidth = containerWidth - (gap * (columns - 1));
      const finalItemWidth = Math.max(80, Math.floor(availableWidth / columns));
      
      document.documentElement.style.setProperty('--masonry-item-width', `${finalItemWidth}px`);
      document.documentElement.style.setProperty('--masonry-columns', columns);
      
      items.forEach((item) => {
        item.style.width = `${finalItemWidth}px`;
        item.style.maxWidth = `${finalItemWidth}px`;

        if (realtime) {
          item.style.display = 'block';
          item.style.visibility = 'visible';
        }
        
        const img = item.querySelector('img');
        if (img) {
          img.style.width = '100%';
          img.style.height = 'auto';
          img.style.display = 'block';
          img.style.maxWidth = `${finalItemWidth}px`;
          
          const imageReady = realtime
            ? img.naturalWidth > 0 && img.naturalHeight > 0
            : img.complete && img.naturalWidth > 0 && img.naturalHeight > 0;

          if (imageReady) {
            const aspectRatio = img.naturalHeight / img.naturalWidth;
            const calculatedHeight = finalItemWidth * aspectRatio;
            const maxAllowedHeight = Math.min(calculatedHeight, window.innerHeight * 0.9);
            img.style.maxHeight = `${maxAllowedHeight}px`;
            img.style.minHeight = `${Math.min(calculatedHeight, maxAllowedHeight)}px`;
          }
        }
        
        item.offsetHeight; // Force reflow
        
        this.positionMasonryItem(item, columnHeights, gap, finalItemWidth, realtime);
      });
      
      container.style.height = `${Math.max(...columnHeights)}px`;
    },
    
    positionMasonryItem(item, columnHeights, gap, itemWidth, realtime = false) {
      const shortestColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
      const x = shortestColumnIndex * (itemWidth + gap);
      const y = columnHeights[shortestColumnIndex];
      
      item.style.position = 'absolute';
      item.style.left = `${x}px`;
      item.style.top = `${y}px`;
      
      const itemHeight = realtime ? (item.offsetHeight || 200) : item.offsetHeight;
      columnHeights[shortestColumnIndex] += itemHeight + gap;
    },
    getMasonryColumns() {
      const width = this.windowWidth || window.innerWidth;
      
      let columns;
      if (width < 480) columns = 2;           // Mobile portrait
      else if (width < 768) columns = 3;      // Mobile landscape / Small tablet
      else if (width < 1024) columns = 4;     // Tablet
      else if (width < 1550) columns = 5;     // Desktop
      else columns = 6;                       // Large desktop
      
      return columns;
    }
  },
};
</script>

<style scoped>
input[type="checkbox"] {
  display: none;
}

div.gallery:hover {
  cursor: pointer;
  opacity: 0.9;
}

div.gallery_hl:hover {
  cursor: pointer;
  opacity: 0.7;
}

@media screen and (min-width: 851px) and (max-width: 9000px) {
  div.gallery {
    margin: 1px;
    float: left;
    min-height: auto;
    max-height: 193px;
    min-width: auto;
    max-width: 290px;
  }

  div.gallery img {
    position: relative;
    min-height: 100%;
    max-height: 194.66px;
    min-width: 100%;
    padding: 1px;
    max-width: 290px;
  }

  div.gallery_hl {
    margin: 2px;
    float: left;
    min-height: auto;
    max-height: 229px;
    min-width: auto;
    max-width: 346px;
  }

  div.gallery_hl img {
    position: relative;
    min-height: 100%;
    max-height: 231.66px;
    min-width: 100%;
    padding: 0.5px;
    max-width: 346px;
  }
}

@media screen and (min-width: 451px) and (max-width: 850px) {
  div.gallery {
    margin: 1px;
    float: left;
    min-height: auto;
    max-height: 193px;
    min-width: auto;
    max-width: 290px;
  }

  div.gallery img {
    position: relative;
    min-height: 100%;
    max-height: 194.66px;
    min-width: 100%;
    padding: 1px;
    max-width: 290px;
  }

  div.gallery_hl {
    margin: 2px;
    float: left;
    min-height: auto;
    max-height: 225px;
    min-width: auto;
    max-width: 340px;
  }

  div.gallery_hl img {
    position: relative;
    min-height: 100%;
    max-height: 225.96px;
    min-width: 100%;
    padding: 0.5px;
    max-width: 340px;
  }
}

@media (min-width: 300px) and (max-width: 450px) {
  div.gallery {
    width: 49%;
    float: left;
    margin: 1px;
    padding: 1px;
    /* border: 1px solid #ccc; */
    box-shadow: 4px -10px 35px -30px rgba(0,0,0,0.57);
  }

  div.gallery img {
    min-height: 100%;
    max-height: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 2px;
  }

  div.gallery_hl {
    width: 49%;
    float: left;
    margin: 1px;
    /* padding: 1px;
    border: 1px solid #ccc; */
    box-shadow: 4px -10px 35px -30px rgba(0,0,0,0.57);
  }

  div.gallery_hl img {
    min-height: 100%;
    max-height: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 2px;
  }
}

.drop-container {
  position: relative;
  display: flex;
  gap: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100px;
  padding: 20px;
  border-radius: 10px;
  border: 1px dashed #000000;
  cursor: pointer;
  transition: background 0.2s ease-in-out, border 0.2s ease-in-out;
}
.drop-container {
  background: #99989846;
}
.drop-container:hover {
  background: #979696ad;
}
/* 
.drop-container:hover .drop-title {
  color: #222;
} */

.drop-title {
  color: #444;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  transition: color 0.2s ease-in-out;
}

input[type="file"] {
  display: none;
}

/* Progress Bar Styles */
.progress-container {
  width: 100%;
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin: 10px 0;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #0486d6, #00a8ff);
  border-radius: 4px;
  transition: width 0.3s ease;
  min-width: 2px;
}

.event {
  position: relative;
  width: auto;
  height: auto;
}

.event img {
  height: auto;
  width: auto;
}

.event .btn {
  position: absolute;
  top: 86%;
  left: 82%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #0486d6;
  color: white;
  padding: 3px 3px;
  border: 1px;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}
.event .btn-free-download {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #0486d6;
  color: white;
  padding: 3px 3px;
  border: 1px;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.event .btn-delete {
  position: absolute;
  top: 86%;
  left: 82%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #ff1c1c;
  color: white;
  padding: 3px 5px;
  border: none;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.event .btn-delete-go-to-cart {
  position: absolute;
  top: 10%;
  left: 80%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #ff1c1c;
  color: white;
  padding: 3px 3px;
  border: none;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.event_hl {
  position: relative;
  width: auto;
  height: auto;
}

.event_hl img {
  height: auto;
  width: auto;
}

/* When .gallery is inside masonry, let JS control the height (same as gallery_hl) */
.masonry-container .gallery {
  max-height: none;
  min-height: auto;
  float: none;
  width: 100%;
  margin: 0;
}

.masonry-container .gallery img {
  max-height: none !important;
  min-height: auto !important;
  width: 100% !important;
  height: auto !important;
  display: block;
}

/* Masonry Gallery Styles */
.masonry-container {
  position: relative;
  width: 100%; /* Use full width available */
  margin: 5px auto;
}

.masonry-item {
  margin-bottom: 8px;
  break-inside: avoid;
  box-sizing: border-box;
  min-width: 0;
}

.masonry-item:hover {
  z-index: 1;
}

.masonry-content {
  position: relative;
  border-radius: 2px;
  overflow: hidden;
  width: 100%;
}

.masonry-content:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.2);
}

.masonry-content img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 2px;
  max-width: 100%;
  max-height: 90vh; /* Allow more height */
  object-fit: cover; /* Changed back to cover for better space usage */
  transition: transform 0.2s ease-out;
}

/* Dynamic responsive sizing using CSS custom properties */
:root {
  --masonry-item-width: 200px;
  --masonry-columns: 5;
}

/* Responsive masonry columns - dynamic width calculation */
@media screen and (min-width: 1400px) {
  :root {
    --masonry-columns: 6;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1399px) {
  :root {
    --masonry-columns: 5;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  :root {
    --masonry-columns: 4;
  }
}

@media screen and (min-width: 480px) and (max-width: 767px) {
  :root {
    --masonry-columns: 3;
  }
}

@media screen and (max-width: 479px) {
  :root {
    --masonry-columns: 2;
  }
}

/* Force image dimensions to fill container completely */
.masonry-item img {
  width: 100% !important;
  height: auto !important;
  max-width: 100% !important;
  max-height: 90vh !important; /* Allow more vertical space */
  display: block !important;
  border-radius: 2px;
  object-fit: cover !important; /* Fill space completely */
}

/* Override old gallery_hl styles for masonry */
.masonry-container .gallery_hl {
  margin: 0;
  float: none;
  width: 100%;
  height: auto;
  min-height: auto;
  max-height: none;
  min-width: auto;
  max-width: none;
  overflow: hidden;
}

.masonry-container .gallery_hl img {
  width: 100% !important;
  height: auto !important;
  padding: 0;
  min-height: auto;
  max-height: 90vh !important; /* Allow more vertical space */
  min-width: auto;
  max-width: 100% !important;
  object-fit: cover !important; /* Fill space completely */
}
/*
.event .btn:hover {
  background-color: black;
}
.event .btn-delete:hover {
  background-color: black;
}
*/
</style>
    
